module.exports = __webpack_public_path__ + "static/media/HCMM714.875e1ac9.jpg";